import React, { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import { Toast } from '../../../services';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";

const ConfirmPrompt = ({ data }: any) => {
    const { isOpenConfirm, setIsOpenConfirm, prompt, setIsPromptDeleted, getPrompts } = data;

    const deletePrompt = () => {
        HttpService.deleteRequest(API_URL.DELETE_PROMPT + "/" + prompt.id).then(
            (res: any) => {
                setIsOpenConfirm(false);
                setIsPromptDeleted(true);
                Toast(`Prompt "${prompt.name}" moved to Recycle Bin successfully.`, "success");
                setTimeout(() => {
                    getPrompts();
                }, 1000);
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        )
    }

    return (
        <div className='custom-modal'>
            <Modal
                isOpen={isOpenConfirm}
                srLabelledBy={'modal-id-confirm-delete'}
                srDescribedBy={'modal-id-confirm-delete'}>
                <ModalHeader
                    titleId={'modal-id-confirm-delete'}
                    isFullscreenButtonVisible
                    onUserRequest={() => setIsOpenConfirm(false)}>
                    Confirm
                </ModalHeader>
                <ModalBody descriptionId="modal-id-confirm-delete">
                    <span className='bold'>{prompt?.name}</span><br />
                    This prompt will be removed from the library and stored in the Recycle Bin for the next 60 days. Do you want to continue?
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'text'}>
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() => setIsOpenConfirm(false)}>
                                    Cancel
                                </button>
                            </ButtonField>
                            <ButtonField>
                                <button
                                    type="button"
                                    id="defaultClose"
                                    onClick={() => deletePrompt()}>
                                    Yes
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmPrompt;
